import React from 'react';
import './SidebarToggle.css';

interface SidebarToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const SidebarToggle: React.FC<SidebarToggleProps> = ({ isCollapsed, onToggle }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <button
      className="sidebar-toggle"
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      aria-expanded={!isCollapsed}
      title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
    >
      <span className="toggle-icon" aria-hidden="true">
        {isCollapsed ? '→' : '←'}
      </span>
    </button>
  );
};

export default SidebarToggle;
